export default {
      id: "baby_changing_station-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#baby_changing_station",
      toString: function () {
        return this.url;
      }
    }